import { nprogress } from 'redux-nprogress';
import layout from "./layout"
import content from "./content"
import articles from "./articles"
import trending from "./trending"
import menu from "./menu"
import shopTheLook from './shopTheLook'
import search from './search'
import dropdown from './dropdown'
import experiments from './experiments'
import userMetadata from './userMetadata'
import universalMenu from './universal-menu'
import account from './account'
import products from './products'

export default {
    account,
    layout,
    content,
    articles,
    trending,
    menu,
    shopTheLook,
    search,
    dropdown,
    experiments,
    userMetadata,
    universalMenu,
    nprogress,
    products
};



// WEBPACK FOOTER //
// ./src/reducers/index.js